export enum UserTypeEnum {
  NOT_LOGGED_IN = 'NotLoggedIn',
  LOGGED_IN = 'LoggedIn',
  ALL = 'All',
  STUDENTS = 'Student',
  TEACHERS = 'Teacher',
}
